@import 'styles/mixins';
@import 'styles/variables';

.divider {
  background: $gray-10;
  width: 1px;
  height: 100%;
  min-height: 30px;
  max-height: 64px;
  border: none;
  margin: auto 8px auto;

  &.noMargin {
    margin: 0;
  }
}

.disabled {
  opacity: 0.3;
}

:global(.in-more) {
  .divider {
    display: none !important;
  }
}
